module.exports = __webpack_public_path__ + "img/chevron-right-icon.4e0552e8.svg";